import React from "react";
import { Auth0Provider } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import env from "../config/env";

const Auth0ProviderWithHistory = ({ children }) => {
  const domain = env.REACT_APP_DOMAIN;
  const clientId = env.REACT_APP_CLIENTID;
  const redirectUri = env.REACT_APP_REDIRECTURI;
  const audience = env.REACT_APP_AUDIENCE;

  const navigate = useNavigate();

  const onRedirectCallback = (appState) => {
    navigate(appState?.returnTo || window.location.pathname);
  };

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      useRefreshTokens={true}
      authorizationParams={{
        redirect_uri: redirectUri,
        audience: audience,
        scope: "openid profile email",
      }}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
